import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 15 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": ".938",
      d: "M7.5 14.25c3.438 0 6.25-2.813 6.25-6.25 0-3.438-2.813-6.25-6.25-6.25-3.438 0-6.25 2.813-6.25 6.25 0 3.438 2.813 6.25 6.25 6.25m0-8.75v3.125"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M7.497 10.5h.005"
    }, null, -1)
  ]))]))
}
export default { render: render }